import type { MantineSize } from "@mantine/core";

export function getSmallerSize(size?: MantineSize) {
  switch (size) {
    case "xl":
      return "lg";
    case "lg":
      return "md";
    case "md":
      return "sm";
    case "sm":
    case "xs":
      return "xs";
    default:
      return size;
  }
}
